import { CruisePulseProvider } from '@rcg/cruise-pulse';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useFeatureFlags } from 'hooks/LaunchDarkly/useFeatureFlags';
import { useContext, useMemo } from 'react';

export const CruisePulseWrapper = ({ children }) => {
	const { brand, locale, results }: any = useContext(CruiseSearchContext);
	const { enableUrgencyMessaging } = useFeatureFlags();

	const itineraryIdsArray = useMemo(() => results.cruises.map((cruise) => cruise.id), [results.cruises]);

	return enableUrgencyMessaging ? (
		<CruisePulseProvider brand={brand} locale={locale.language} country={locale.country} itineraryIds={itineraryIdsArray}>
			{children}
		</CruisePulseProvider>
	) : (
		<>{children}</>
	);
};
